export const SET_PERCENTAGE = "SET_PERCENTAGE";
export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const SET_USER_COMING_FROM_BUILD_FLOW =
  "SET_USER_COMING_FROM_BUILD_FLOW";
